<template>
    <div class="qksm">
        <p><b>（一）2022年重点工作目标</b></p>
        <div class="deptCon">
            <reason type="textarea" rows="5" classname="qksm format" name="Q1" v-model:value="qksm['Q1']"></reason>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm1",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        components: {
            reason,
        },
    };

</script>